
import { motion } from 'framer-motion';
import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const timeline = [
  {
    period: '2022 — Presente',
    role: 'Estrategista de IA & Fundador',
    company: 'jVaz · Produtos e Consultoria',
    desc: 'Criação e lançamento de produtos próprios: Mentoria IA para Negócios (método PPA), Builder (curso para não-devs), BuscaRápida (SaaS WhatsApp + Linx/Bling), Cod2D (GS1 Digital Link), Plataforma White-Label e Análise Cognitiva.',
  },
  {
    period: '2020 — 2022',
    role: 'Consultor de Transformação Digital',
    company: 'Autônomo',
    desc: 'Implementação de automações e sistemas de IA em empresas de médio porte. Desenvolvimento do Método PPA — estrutura de diagnóstico, implementação e autonomia em 90 dias.',
  },
  {
    period: '2018 — 2020',
    role: 'Desenvolvedor Sênior & Mentor',
    company: 'Magazine Luiza / Projetos próprios',
    desc: '1º lugar no Hackathon do Magalu com solução de otimização logística. Início da mentoria para profissionais em transição de carreira para tecnologia.',
  },
  {
    period: '2016 — 2018',
    role: 'Analista de Sistemas',
    company: 'Innovate Software',
    desc: 'Desenvolvimento e manutenção de ERPs — ciclo completo desde levantamento de requisitos até implantação. Vencedor do Startup Weekend com solução para educação.',
  },
  {
    period: '2012 — 2016',
    role: 'Desenvolvedor Web & Suporte',
    company: 'Digital Solutions / TechSupport',
    desc: 'Desenvolvimento de aplicações web para múltiplos segmentos. Suporte a usuários de sistemas ERP. Base técnica em HTML/CSS, JavaScript, PHP e infraestrutura Linux.',
  },
];

const awards = [
  { year: '2019', title: '1º Lugar · Hackathon Magalu', desc: 'Solução de otimização logística que gerou economia significativa e melhor experiência do cliente.' },
  { year: '2017', title: 'Vencedor · Startup Weekend', desc: 'Solução tecnológica para educação reconhecida pelo potencial de impacto social e viabilidade comercial.' },
];

const ExperiencePage = () => {
  return (
    <>
      <SeoHead
        route="/experience"
        lang="pt-BR"
        title="Experiência — Johnny Vaz"
        description="Trajetória profissional de Johnny Vaz: de desenvolvedor a estrategista de IA. 20+ anos entre tecnologia, empreendedorismo e construção de produtos."
      />
      <Navbar />

      {/* Hero */}
      <section style={{ backgroundColor: '#0B0B0B', paddingTop: '7rem', paddingBottom: '4rem' }}>
        <div className="container mx-auto px-6 max-w-4xl">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1.25rem' }}>
              Trajetória · Johnny Vaz
            </p>
            <h1 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(3rem, 9vw, 6.5rem)', lineHeight: 0.88, letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#F2EDE3', marginBottom: '2rem' }}>
              EXPERIÊNCIA<br />
              <span style={{ color: '#FF4500' }}>PROFISSIONAL</span>
            </h1>
            <div style={{ height: '2px', backgroundColor: '#FF4500', width: '64px', marginBottom: '2rem' }} />
            <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: 'clamp(1rem, 2.2vw, 1.2rem)', lineHeight: 1.65, color: '#8C8377', maxWidth: '520px' }}>
              De suporte técnico a estrategista de IA. 20+ anos construindo produtos,
              treinando times e implementando tecnologia em negócios reais.
            </p>
          </motion.div>
        </div>
      </section>

      <main>
        {/* Timeline */}
        <section style={{ backgroundColor: '#0B0B0B', padding: '3rem 0 5rem' }}>
          <div className="container mx-auto px-6 max-w-3xl">
            <div style={{ position: 'relative' }}>
              {/* Linha vertical */}
              <div style={{ position: 'absolute', left: '0', top: 0, bottom: 0, width: '2px', backgroundColor: 'rgba(255,69,0,0.25)' }} />

              <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {timeline.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -16 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    style={{ paddingLeft: '2.5rem', paddingBottom: '3rem', position: 'relative' }}
                  >
                    {/* Dot */}
                    <div style={{ position: 'absolute', left: '-5px', top: '6px', width: '12px', height: '12px', backgroundColor: '#FF4500', borderRadius: '50%' }} />

                    <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.65rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '0.4rem' }}>
                      {item.period}
                    </p>
                    <h3 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(1.2rem, 3vw, 1.6rem)', lineHeight: 0.95, textTransform: 'uppercase', color: '#F2EDE3', marginBottom: '0.3rem' }}>
                      {item.role}
                    </h3>
                    <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.65rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C8377', marginBottom: '0.75rem' }}>
                      {item.company}
                    </p>
                    <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.9rem', lineHeight: 1.65, color: '#8C8377' }}>
                      {item.desc}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Premiações */}
        <section style={{ backgroundColor: '#F2EDE3', padding: '5rem 0' }}>
          <div className="container mx-auto px-6 max-w-4xl">
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1rem' }}>
              Reconhecimentos
            </p>
            <h2 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: 0.92, letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#0B0B0B', marginBottom: '0.75rem' }}>
              PREMIAÇÕES &<br /><span style={{ color: '#FF4500' }}>CONQUISTAS</span>
            </h2>
            <div style={{ height: '2px', backgroundColor: '#FF4500', width: '64px', marginBottom: '3rem' }} />
            <div className="grid md:grid-cols-2 gap-1">
              {awards.map((a) => (
                <div key={a.title} style={{ border: '1px solid rgba(11,11,11,0.12)', padding: '2rem' }}>
                  <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.65rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '0.5rem' }}>
                    {a.year}
                  </p>
                  <h3 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: '1.3rem', lineHeight: 1, textTransform: 'uppercase', color: '#0B0B0B', marginBottom: '0.75rem' }}>
                    {a.title}
                  </h3>
                  <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.9rem', lineHeight: 1.6, color: '#1A1916' }}>
                    {a.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ExperiencePage;
